import { Component } from '@angular/core';

@Component({
  selector: 'app-confirma-delete',
  templateUrl: './confirma-delete.component.html',
  styleUrls: ['./confirma-delete.component.scss']
})
export class ConfirmaDeleteComponent{

  constructor() { }

  ngOnInit(): void {
  }
}
